var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"Página no encontrada","back-link":_vm.$t('atras')}}),_vm._v(" "),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Error: Página no encontrada")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }